import { render, staticRenderFns } from "./injuryDetail.vue?vue&type=template&id=28316d4c&scoped=true"
import script from "./injuryDetail.vue?vue&type=script&lang=js"
export * from "./injuryDetail.vue?vue&type=script&lang=js"
import style0 from "./injuryDetail.vue?vue&type=style&index=0&id=28316d4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28316d4c",
  null
  
)

export default component.exports